import { render, staticRenderFns } from "./MmfLimitationAlert.vue?vue&type=template&id=73252b52&"
import script from "./MmfLimitationAlert.vue?vue&type=script&lang=js&"
export * from "./MmfLimitationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports